import * as RefApi from 'saas/references/api';
import * as WorkerApi from 'saas/users/api';
import { createAction } from 'redux-actions';
import * as RefConstants from 'saas/references/constants';

export const fetchRequirementsAction = createAction('case.FETCH_REQUIREMENTS');
export const fetchRequirementsSuccessAction = createAction(
  'case.FETCH_REQUIREMENTS_SUCCESS'
);

export const fetchRequirements = siteCase => (dispatch, getState) => {
  if (getState().requirements.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchRequirementsAction);

  const doFetch = () =>
    Promise.all([
      WorkerApi.getAllWorkers(),
      RefApi.getReferencesByType(RefConstants.TECH_EPI, siteCase),
      RefApi.getReferencesByType(RefConstants.INVENTORY_TO_PLAN, siteCase),
    ]);

  // Fetching requirements and planning
  const promise = doFetch().then(response =>
    dispatch(
      fetchRequirementsSuccessAction({
        workers: response[0],
        securityEpis: response[1],
        inventoryToPlan: response[2],
      })
    )
  );

  return promise;
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step3/actions/requirements.js